export default __webpack_public_path__ + "assets/front/scss/collaborative-indexation.f50b99000c192ff1c003544d6c8eb06f.css";